import es from './es-ES/texts.po.json'
import pt from './pt-PT/texts.po.json'

export default {
  es,
  pt
}
